module.exports = __webpack_public_path__ + "static/img/81009D_3_C_20230615_fit.eebbd2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/81009D_3_C_20230615_fit.png
// module id = j8tv
// module chunks = 0